// @flow
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Card, Col, Row} from 'reactstrap';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import {useByteFormat} from '../../../shared/hooks/useByteFormat';

type FileUploaderProps = {
    size: 'lg' | 'md' | 'sm',
    onFileUpload?: PropTypes.func,
    multiple?: boolean,
    preview?: boolean,
};

type FileUploaderState = {
    selectedFiles: Array<PropTypes.object>,
};

class FileUploader extends Component<FileUploaderProps, FileUploaderState> {
    static defaultProps = {
        size: 'sm',
        multiple: true,
        preview: true,
        message: 'Drop file here or click to upload.',
        subMessage: '(The following format are accepted: JPG/PNG/TIFF/PDF)',
    };

    constructor(props: FileUploaderProps) {
        super(props);
        this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);

        this.state = {
            selectedFiles: [],
            singleFile: null,
        };
    }

    /**
     * Handled the accepted files and shows the multiple
     */
    handleAcceptedFiles = (files: Array<PropTypes.object>) => {
        if (!files || files.length === 0) {
            return
        }

        let allFiles = files;

        if (this.props.multiple) {
            files.map(file =>
                Object.assign(file, {
                    preview: file['type'].split('/')[0] === 'image' ? URL.createObjectURL(file) : null,
                    formattedSize: useByteFormat(file.size),
                })
            );

            allFiles = this.state.selectedFiles;
            allFiles.push(...files);
        } else {
            let file = allFiles[0];
            file = Object.assign(file, {
                preview: allFiles[0]['type'].split('/')[0] === 'image' ? URL.createObjectURL(file) : null,
                formattedSize: useByteFormat(file.size),
            });
            allFiles = [file];

            this.setState({
                singleFile: file,
            })
        }

        this.setState({selectedFiles: allFiles});
        if (this.props.onFileUpload) this.props.onFileUpload(allFiles);
    };

    render() {
        return (
            <React.Fragment>
               
                <Dropzone onDrop={acceptedFiles => this.handleAcceptedFiles(acceptedFiles)} {...this.props}>
                    {({getRootProps, getInputProps}) => (
                        <div className={`dropzone size-${this.props.size}`}>
                            <div className={`dz-message size-${this.props.size} needsclick`} {...getRootProps()}>
                                <input {...getInputProps()} />
                                <i className="mdi mdi-cloud-upload"/>
                                <h5>{this.props.message}</h5>
                                <span className="text-muted">
                                    {this.props.subMessage}
                                </span>
                            </div>
                        </div>
                    )}
                </Dropzone>

                {this.props.preview && !this.props.multiple && this.state.singleFile && (
                    <Card
                        className="mt-1 mb-2 shadow-none border dz-processing dz-image-multiple dz-success dz-complete">
                        <div className="p-2">
                            <Row className="align-items-center">
                                <Col className="col-auto">
                                    {
                                        this.state.singleFile.preview
                                        ? <img
                                            data-dz-thumbnail=""
                                            className="avatar-sm rounded bg-light"
                                            alt={this.state.singleFile.name}
                                            src={this.state.singleFile.preview}
                                        />
                                        : <div className="avatar-sm">
                                            <span className="avatar-title bg-primary rounded">
                                                <i className="h2 mdi mdi-file"></i>
                                            </span>
                                        </div>
                                    }
                                </Col>
                                <Col className="pl-0">
                                    <Link to="#" className="text-muted font-weight-bold">
                                        {this.state.singleFile.name}
                                    </Link>
                                    <p className="mb-0">
                                        <strong>{this.state.singleFile.formattedSize}</strong>
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                )
                }

                {this.props.preview && this.props.multiple && (
                    <div className="dropzone-previews mt-3" id="file-previews">
                        {this.state.selectedFiles.map((f, i) => {
                            return (
                                <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-multiple dz-success dz-complete"
                                    key={i + '-file'}>
                                    <div className="p-2">
                                        <Row className="align-items-center">
                                            {f.multiple && (
                                                <Col className="col-auto">
                                                    <img
                                                        data-dz-thumbnail=""
                                                        className="avatar-sm rounded bg-light"
                                                        alt={f.name}
                                                        src={f.preview}
                                                    />
                                                </Col>
                                            )}
                                            {!f.multiple && (
                                                <Col className="col-auto">
                                                    <div className="avatar-sm">
                                                        <span className="avatar-title bg-primary rounded">
                                                            {f.type.split('/')[0]}
                                                        </span>
                                                    </div>
                                                </Col>
                                            )}
                                            <Col className="pl-0">
                                                <Link to="#" className="text-muted font-weight-bold">
                                                    {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                    <strong>{f.formattedSize}</strong>
                                                </p>
                                            </Col>
                                        </Row>
                                    </div>
                                </Card>
                            );
                        })}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default FileUploader;
